import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, AfterViewChecked, Inject } from '@angular/core';
import { AuthenticationService, DropdownsService } from 'app/services';
import { Subject, merge, Observable, forkJoin } from 'rxjs';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { map, concat, remove, forEach, last, split, isEmpty } from 'lodash';
import { Router } from '@angular/router';
import { ComposeEmailsService } from 'app/services/compose-emails.service';
import { TranslateService } from '@ngx-translate/core';
import { PdfListDialogComponent } from 'app/directives/pdf-templates/pdf-list-dialog/pdf-list-dialog.component';
import { fuseAnimations } from '@fuse/animations';
import { startWith, tap, switchMap, takeUntil, debounceTime, take } from 'rxjs/operators';
import { AttachmentsService } from 'app/services/attachments.service';
import { PreviewEmailComponent } from 'app/directives/compose-email/preview-email/preview-email.component';
import { QuickAddComponent } from 'app/main/master-data/accounts/quick-add/quick-add.component';
import { CommercialPropertiesService } from 'app/services/commercial-properties.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { environment } from 'environments/environment';
import { GLOBALS } from 'app/config/globals';
import { GetCommercialReferencePipe } from 'app/pipes/get-commercial-reference.pipe';

@Component({
  selector: 'commercial-print',
  templateUrl: './commercial-print.component.html',
  styleUrls: ['./commercial-print.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
  providers: [GetCommercialReferencePipe]
})
export class CommercialPrintComponent implements OnInit, AfterViewChecked {
  user: any;
  pdf: UntypedFormGroup;
  filter = {} as any;
  emails: string[] = [];
  attachments: string[] = [];
  private _unsubscribeAll: Subject<any>;
  emailsCtrl = new UntypedFormControl('');
  templatesCtrl = new UntypedFormControl('');
  showExtraToFields: boolean;
  downloadFiles = {
    urls: [],
    names: []
  } as any;
  currentLang: string;
  properties: any;
  searching: boolean;
  public propertySearch = new Subject<string>();
  filteredEmials: Observable<string[]>;
  filteredTemplates: Observable<any>;
  accountSearch$ = new Subject<string>();
  accounts = [] as any;
  loadingAccounts = false;
  currentAgency: any;

  emailSearch$ = new Subject<string>();
  emailsData = [] as any;
  loadingEmails = false;
  sign = '';
  public tinyMc = GLOBALS.tinyMce; // To use centralized tinyMce
  constructor(
    private _authenticationService: AuthenticationService,
    public formBuilder: UntypedFormBuilder,
    private router: Router,
    private _composeEmailsService: ComposeEmailsService,
    private _translateService: TranslateService,
    private _snackBar: MatSnackBar,
    private _matDialog: MatDialog,
    private _dropdownsService: DropdownsService,
    private _commercialService: CommercialPropertiesService,
    private cdRef: ChangeDetectorRef,
    private _attachmentsService: AttachmentsService,
    public dialogRef: MatDialogRef<CommercialPrintComponent>,
    private cpReference: GetCommercialReferencePipe,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.currentLang = this._translateService.currentLang === 'es' ? 'es_AR' : this._translateService.currentLang;
    this._unsubscribeAll = new Subject();
    this.user = _authenticationService.currentUserValue;
    this.currentAgency = this._authenticationService.currentAgencyValue;
    this.showExtraToFields = false;
    this.filteredEmials = this.emailsCtrl.valueChanges.pipe(
      startWith(''),
      switchMap(() => {
        return this._dropdownsService.getUserEmails(this.emailsCtrl.value);
      }),
    );
    this.filteredTemplates = this.templatesCtrl.valueChanges.pipe(
      startWith(''),
      switchMap(() => {
        let type='commercials_to_accounts';
        return this._dropdownsService.getEmailsTemplates(this.templatesCtrl.value, type);
      }),
    );
    this.filter.query = {};
  }

  ngOnInit(): void {
    let property = '';
    if (this.data && this.data.selectedItems){
      this.filter.query._id = { $in: this.data.selectedItems };
      property = this.data.selectedItems;
    }

    
    this.pdf = this.formBuilder.group({
      download: (false),
      hd: (false),
      email: (true),
      model: 'commercials',
      properties_interested: { value: property, disabled: false },
      mail: this.formBuilder.group({
        to: (''),
        files: (''),
        from: { value: this.user.user_email, disabled: true },
        subject: (''),
        content: (''),
        cc: (''),
        bcc: (''),
        client: new UntypedFormControl({ value: '', disabled: false }),
        account: new UntypedFormControl({ value: '', disabled: false }),
        thumbnail: false,
        dell_bucket: new UntypedFormControl({ value: 'true', disabled: false }),
        client_with_email: new UntypedFormControl({ value: '', disabled: false }),
      }),
      wl: []
    });
    this.pdf.get('mail.thumbnail').valueChanges.subscribe(() => {
      if (this.pdf.get('mail.thumbnail').value) {
          if (!this.pdf.get('mail.content').value) {
              this.pdf.get('mail.content').setValue('');
          }
          if (this.pdf.get('mail.content').value.indexOf('[cp_thumbnails_links') < 0 && this.currentLang === 'es_AR') {
              this.pdf.get('mail.content').setValue('[cp_thumbnails_links_three lang=ES] <br> ' + this.pdf.get('mail.content').value);
          } else if (
              this.pdf
                  .get('mail.content')
                  .value.indexOf('[cp_thumbnails_links') < 0
          ) {
              this.pdf
                  .get('mail.content')
                  .setValue(
                      '[cp_thumbnails_links_three lang=EN] <br> ' +
                          this.pdf.get('mail.content').value
                  );
          }
      }
    });
    if (this.data.account && this.data.account._id) {
      this.pdf.get('mail.client').setValue(this.data.account._id);
      this.onClientSelect(this.data.account);
    }
    this.emailSearch$
      .pipe(
        debounceTime(200),
        startWith(''),
        tap(() => this.loadingEmails = true),
        takeUntil(this._unsubscribeAll),
        switchMap((search: string) => {
          if (!search) {
            search = '';
          }
          return this._dropdownsService.getUserEmails(search);
        })
      )
      .subscribe((data: any) => {
        if (data) {
          data.length > 0 ? data.push(this.currentAgency.agency_email) : [];
          this.emailsData = data;
        }
        this.loadingEmails = false;
      });

    this.accountSearch$
      .pipe(
        debounceTime(200),
        tap(() => this.loadingAccounts = true),
        startWith(''),
        takeUntil(this._unsubscribeAll),
        switchMap((search: string) => {
          if (!search) {
            search = '';
          }
          return this._dropdownsService.getClientAccount(search);
        })
      )
      .subscribe((data: any) => {
        const accounts = map(data.body, (account) => {
          account.label = account.reference;
          if (account.forename && account.surname) {
            account.label = account.forename + ' ' + account.surname;
          } else {
            account.label = account.email;
          }
          return account;
        });
        this.accounts = accounts;
        this.loadingAccounts = false;
      });
      merge(this.propertySearch, this.pdf.get('properties_interested').valueChanges).pipe(
          startWith(''),
          tap(() => (this.searching = true)),
          switchMap((search: string) => {
              this.filter = {
                from_crm: 1,
                query: {archived: { $ne: true },} as any,
                options: { limit: 40, sort: { reference: -1}},
              } as any;

              const queryOr = [];
              if (this.data?.selectedItems) {
                queryOr.push({_id: { $in: this.data.selectedItems }});
              }
              if (search.length) {
                queryOr.push({reference: Number(search),});
                queryOr.push({external_reference: {$regex: '.*' + search + '.*',$options: 'i',},});
                queryOr.push({other_reference: { $regex:'.*' + search + '.*',$options: 'i',},});
              }
              if(queryOr.length){
                this.filter.query.$or = queryOr;
              }
              return this._commercialService.getData(this.filter);
          })
      )
          .subscribe((data: any) => {
              this.searching = false;
              for (const property of data.docs) {
                property.label = this.cpReference.transform(property)
              }
              this.properties = data.docs;
          });

  }
  closeDialog(action: string): void {
    const emails = map(this.emails, (e) => ({ email: e }));
    this.pdf.get('mail.to').setValue(emails);
    this.pdf.get('mail.files').setValue(this.attachments);
    // this.matDialogRef.close([action, this.composeForm]);
    if (action === 'send') {
      this._composeEmailsService.sendEmail(this.pdf.getRawValue())
        .subscribe((result) => {
          console.log(result);
          this._snackBar.open(this._translateService.instant('Send successfully'), this._translateService.instant('Close'), {
            duration: 2000,
          });
          this.dialogRef.close(); 
          //   this.router.navigate(['/commercials/index']);          
        });

    }
  }
  onSelectFile(files: FileList): void {
    const uploader = [];
    forEach(files, (file: File) => {
      uploader.push(this._attachmentsService.mailAttachment(file));
    });
    forkJoin(uploader)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((data: any) => {
        const attachments = map(data, (url) => last(split(url, '/')));
        this.attachments = concat(this.attachments, attachments);
      }, () => { });
  }
  onClientSelect(accounts): void {
    if(!Array.isArray(accounts)) {
        accounts = [accounts];
    }
    let mail_client_with_email = [];
    if (accounts) {
      let mail_to_old = [];
      mail_to_old.push(this.pdf.get('mail.to').value);
      this.pdf.get('mail.to').setValue('');
      for(const account of accounts) {
        if (this.pdf.get('mail.to').value !== '' && account.email && account.email !== '') {
          let to = this.pdf.get('mail.to').value;
          if (to.indexOf(account.email) < 0) {
            to = to + ',' + account.email;
            this.pdf.get('mail.to').setValue(to.split(','));
            this.emails.push(account.email);
          }
          this.pdf.get('mail.account').setValue(account._id);
          mail_client_with_email.push({ [account._id]: account.email });
        } else if (account.email && account.email !== '') {
          this.pdf.get('mail.to').setValue([account.email]);
          this.pdf.get('mail.account').setValue(account._id);
          mail_client_with_email.push({ [account._id]: account.email });
          this.emails.push(account.email);
        }
      }
      this.pdf.get('mail.client_with_email').setValue(mail_client_with_email);
    }
  }
  addAccount(event): void {
    event.stopPropagation();
    const dialogRef = this._matDialog.open(QuickAddComponent, {
      panelClass: 'event-form-dialog',
      disableClose: false
    });
    dialogRef.afterClosed()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(result => {
        this.pdf.get('mail.client').setValue(result._id);
        this.accountSearch$.next('');
        this.onClientSelect(result);
      });
  }
  async previewEmail() {
    const templateLanguage = await this.getemplateLanguage();
    const data = {
      to: Array.isArray(this.emails) && !this.emails.length ? '' : this.emails,
      from: this.pdf.get('mail.from').value,
      subject: this.pdf.get('mail.subject').value,
      property_ids: this.pdf.get('properties_interested').value,
      content: this.pdf.get('mail.content').value
    };

    this._matDialog.open(PreviewEmailComponent, {
      disableClose: true,
      panelClass: 'mail-preview-dialog',
      data: data
    });
  }
  setDownloadValue(e: any): void {
    if (e.checked && this.pdf.get('email').value) {
      this.pdf.get('email').setValue(false);
    }
    if (!(e.checked) && !(this.pdf.get('email').value)) {
      this.pdf.get('email').setValue(true);
    }
  }

  setEmailValue(e: any): void {
    if (e.checked && this.pdf.get('download').value) {
      this.pdf.get('download').setValue(false);
    }
    if (!(e.checked) && !(this.pdf.get('download').value)) {
      this.pdf.get('download').setValue(true);
    }
  }

  toggleExtraToFields(): void {
    this.showExtraToFields = !this.showExtraToFields;
  }

  add(event: MatChipInputEvent): void {
    const value = event.value;
    if ((value || '').trim()) {
      this.emails.push(value.trim());
    }
    // Clear the input value
    event.chipInput!.clear();
    
    this.emailsCtrl.setValue('');
  }
  loadSignature(): void {
    if (this.sign) {
      this.sign = '';
    } else {
      this.sign = 'primary';
      if (this._authenticationService.currentUserValue.signature) {
        const parser = new DOMParser();
        // signWithTags remove HTML, body and head tag
        let signWithTags = parser.parseFromString(this._authenticationService.currentUserValue.signature, 'text/html');
        const sanitizedContent = signWithTags?.body?.innerHTML;
        if(typeof(sanitizedContent) != undefined) {
          const currentContent = this.pdf.get('mail.content').value;
          const bodyEndIndex = currentContent.lastIndexOf('</body>');
          const mergedContent = `${currentContent.substring(0, bodyEndIndex)}${sanitizedContent}${currentContent.substring(bodyEndIndex)}`;
          this.pdf.get('mail.content').setValue(mergedContent);
        }
      }
    }
  }
  removeAttachment(file: any): void {
    remove(this.attachments, (el: any) => {
      return el === file;
    });
  }
  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }
  onSelectEmail(event): void {
    this.emails.push(event);
    this.emailsCtrl.setValue('');
  }
  onSelectTemplate(event: any): void {
    this.pdf.get('mail.subject').setValue(event.subject);
    this.pdf.get('mail.content').setValue(event.content);
  }
  remove(fruit: string): void {
    const index = this.emails.indexOf(fruit);
    if (index >= 0) {
      this.emails.splice(index, 1);
    }
  }
  openTemplates(): void {
    const dialogRef = this._matDialog.open(PdfListDialogComponent, {
      panelClass: 'pdf-list-dialog',
      data: {
        viewRecord: true,
        properties: this.pdf.get('properties_interested').value,
        type: 'commercials'
      },
    });
    dialogRef.afterClosed()
      .subscribe(response => {
        if (response) {
          this.downloadFiles = response;
          if (response.names) {
            this.attachments = concat(this.attachments, response.names);
          }
        }
      });
  }
  download(): void {
    this.downloadFiles.urls.forEach(element => {
      window.open(element, '_blank');
    });
  }

  async getemplateLanguage(): Promise<any> {
    return this.filteredTemplates.pipe(take(1)).toPromise().then(data => {
      const firstRecord = data[0];
      const templateLanguage = firstRecord?.template_language;
      return templateLanguage;
    });
  }

}
